import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Spool} from '../../../model/spool';
import {CreateDepositService} from '../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../../services/apiServices/business/common.service';


/**
 * component that permit to create new spool
 */
@Component({
  selector: 'app-create-spool',
  templateUrl: './create-spool.component.html',
  styleUrls: ['./create-spool.component.scss']
})
export class CreateSpoolComponent implements OnInit {
  @Input() customerSpools: Spool[];
  public name: string;
  public fileName: string;
  @Output() public modalDisplay: EventEmitter<boolean>;
  public validSpoolName: boolean;
  public validSpoolFileName: boolean;
  public acceptedFiles = '.xml,.XML';
  @ViewChild('fileUpload', { static: true }) fileUpload;
  successRequestTitle: string;
  private successRequestMessage: string;
  private errorRequestTitle: string;
  private errorRequestMessage: string;

  constructor(private translate: TranslateService, private createDepositService: CreateDepositService, private commonService: CommonService) {
    this.modalDisplay = new EventEmitter<boolean>();
  }

  ngOnInit(): void {
    this.name = '';
    this.fileName = '';
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((label: string) => {
      this.successRequestTitle = label;
    });
    this.translate.get('TOASTER.SUCESS_REQUEST_OK').subscribe((label: string) => {
      this.successRequestMessage = label;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((label: string) => {
      this.errorRequestTitle = label;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_MESSAGE').subscribe((label: string) => {
      this.errorRequestMessage = label;
    });
  }
  public clearFiles(): void {
    this.fileUpload.files = [];
  }
  public checkNameValidity(): void {
    this.validSpoolName = false;
    if (this.name.length < 6) {
      return;
    }
    for (const spool of this.customerSpools) {
      if (spool.name === this.name) {
        this.validSpoolName = false;
        return;
      }
    }
    this.validSpoolName = true;
  }
  public checkFileNameValidity(): void {
    this.validSpoolFileName = false;
    if (this.name.length < 6) {
      return;
    }
    for (const spool of this.customerSpools) {
      if (spool.spoolId === this.fileName) {
        this.validSpoolFileName = false;
        return;
      }
    }
    this.validSpoolFileName = true;
  }
  closeCreateSpool() {
    this.modalDisplay.emit(false);
  }
  createSpool(): void {

    this.createDepositService.createSpool(this.name, this.fileName, this.fileUpload.files[0]).subscribe(response => {

        if (response.body.bOK) {
          this.name = '';
          this.fileName = '';
          this.clearFiles();
          this.checkNameValidity();
          this.checkFileNameValidity();
          this.commonService.addToast({life: 3000,
            severity: 'success',
            summary: this.successRequestTitle,
            detail: this.successRequestMessage
          });
          this.closeCreateSpool();
        } else {
          this.commonService.addToast({life: 3000,
            severity: 'error',
            summary: this.errorRequestTitle,
            detail: this.errorRequestMessage
          });
        }
      }
    );
  }
  public uploadIsPossible() {
    return this.validSpoolName && this.fileUpload.files.length === 1;
  }
}
